import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const bannerImage = lazy(() => import('../../container/pages/bannerImage'));
const addBannerImage = lazy(() => import('../../container/pages/addBannerImage'));
const editBannerImage = lazy(() => import('../../container/pages/editBannerImage'));


function PagesRoute() {
  const { path } = useRouteMatch();
  
  return (
    <Switch>
      <Route path={`${path}/addbannerImage`} component={addBannerImage} />
      <Route path={`${path}/editbannerImage`} component={editBannerImage} />
      <Route path={`${path}/listingImage`} component={bannerImage} />
    </Switch>
  );
}

export default PagesRoute;
